{
  "status": {
    "active": "Active",
    "fading": "Fading",
    "completed": "Completed",
    "dismissed": "Dismissed"
  },
  "effort": {
    "quick": "Quick win",
    "moderate": "Moderate",
    "deep": "Deep work"
  },
  "curve": {
    "warming": "Building urgency",
    "cooling": "Winding down"
  },
  "clear": {
    "title": "Nothing needs you right now.",
    "subtitle": "Go live."
  },
  "summary": {
    "hardCount": "{{count}} things need attention.",
    "fadingCount": "{{count}} are fading out on their own."
  },
  "fadingPrompt": "Does this still matter?",
  "timeline": {
    "title": "Coming up"
  }
}
